import React, { FC } from 'react';
import cx from 'classnames';
import { Link } from 'gatsby';
import emptyImage from 'file-loader!@/assets/images/empty-image.png'; // eslint-disable-line import/no-webpack-loader-syntax
import Card from '@/components/Common/Card';
import { PropsWithClassName } from '@/types/common';
import Asset from '@/components/Common/Asset';
import { ProductSummary } from '@/types/product';
import routes from '@/routes';
import { useI18n } from '@/context/I18n';
import * as styles from './ProductCard.module.scss';

type Props = PropsWithClassName<{
  isFullRow?: boolean;
  product: ProductSummary;
}>;

export const ProductCard: FC<Props> = ({
  className,
  isFullRow,
  product: { name, image, largeImage, pim, slug, sku, collection },
}) => {
  const { locale } = useI18n();
  const nameWithFallback = name || pim?.name;
  const cardImage = isFullRow && largeImage ? largeImage : image;

  return (
    <Card
      className={cx(styles.main, { [styles.fullRow]: isFullRow }, className)}
      image={
        <Link to={routes.product(locale, slug!)} aria-label={name!}>
          <Asset
            className={styles.image}
            asset={cardImage?.gatsbyImageData}
            fallback={emptyImage}
          />
        </Link>
      }
      hasAspectRatio
      body={
        <div className={styles.description}>
          <div>
            {nameWithFallback ? (
              <>
                <Link to={routes.product(locale, slug!)}>{nameWithFallback}</Link>
                <br />
              </>
            ) : null}

            {collection ? (
              <Link to={routes.collection(locale, collection.slug!)}>
                {collection.name}
              </Link>
            ) : null}
            <br />
          </div>
        </div>
      }
    />
  );
};
